import React from 'react'
import frLocale from 'date-fns/locale/fr';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import { Box } from '@mui/system';
import { InputAdornment } from '@mui/material';

import {makeStyles} from '@mui/styles'



const DateTimePicker_Dsas = ({className, name, value, label, onChange, isBorder = true}) => {
    const useStyles = makeStyles(() => ({
        noBorder: {
          borderWidth: isBorder ? '1px!important' : "0px!important",
        },
      }));

    const classes = useStyles();

    

    return (
        <div className={className}>
            <LocalizationProvider className={className} dateAdapter={AdapterDateFns} locale={frLocale}>
            <DateTimePicker 
                label = {label}
                value = {value}
                name = {name}
                onChange={onChange}
                renderInput={(params) => <TextField {...params}/>}
                InputProps={{
                    classes:{notchedOutline:classes.noBorder, focused:classes.noBorder}
                }}
            />
            </LocalizationProvider>
        </div>
)}

export default DateTimePicker_Dsas